import { type BankActivity, BankActivityTypes, EftType, type EftBankActivity } from '@egw/api'

export enum PendingStatusType {
  // eslint-disable-next-line no-unused-vars
  WARNING = 'WARNING',
  // eslint-disable-next-line no-unused-vars
  SUCCESS = 'SUCCESS',
}

export interface PendingStatus {
  type: PendingStatusType
  content: string
}

export const getPendingStatus = (transaction: BankActivity): PendingStatus | undefined => {
  if (transaction.isProcessing) {
    if (transaction.__typename === BankActivityTypes.AchBankActivity && transaction.amount.amount < 0) {
      return {
        type: PendingStatusType.WARNING,
        content: 'TRANSFER_OUT',
      }
    }
    if (transaction.__typename === BankActivityTypes.AchBankActivity && transaction.amount.amount >= 0) {
      return {
        type: PendingStatusType.SUCCESS,
        content: 'TRANSFER_IN',
      }
    }
    if (
      transaction.__typename === BankActivityTypes.EftBankActivity &&
      (transaction as EftBankActivity).eftType === EftType.CARD_PURCHASE
    ) {
      return {
        type: PendingStatusType.WARNING,
        content: 'CARD_PURCHASE',
      }
    }
    if (
      transaction.__typename === BankActivityTypes.EftBankActivity &&
      (transaction as EftBankActivity).eftType === EftType.P2P_OUT
    ) {
      return {
        type: PendingStatusType.WARNING,
        content: 'P2P_OUT',
      }
    }
    if (
      transaction.__typename === BankActivityTypes.EftBankActivity &&
      (transaction as EftBankActivity).eftType === EftType.CARD_PURCHASE_REFUND
    ) {
      return {
        type: PendingStatusType.SUCCESS,
        content: 'CARD_PURCHASE_REFUND',
      }
    }
  }
}
